import { render, staticRenderFns } from "./intention-the-product.vue?vue&type=template&id=525295b2&scoped=true"
import script from "./intention-the-product.vue?vue&type=script&lang=js"
export * from "./intention-the-product.vue?vue&type=script&lang=js"
import style0 from "./intention-the-product.vue?vue&type=style&index=0&id=525295b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525295b2",
  null
  
)

export default component.exports